<template>
  <div @change="validateSection">
    <header>
      <h3>Obstetric Score</h3>
    </header>

    <div class="content">
      <!-- Removed header
      <header><label>OB Score</label></header>
      --->
      <div class="form__row stretch">
        <div class="form__row__item">
          <label normal>G (<i># of Pregnancy</i>)</label>
          <input type="number" class="m" v-model="obscoreG" placeholder="G" min="0"
                 :style="highlightIfError('obscoreG')"
                 :disabled="isClose"/>
        </div>
        <div class="form__row__item">
          <label normal>P (<i># of Delivery</i>)</label>
          <input type="number" class="m" v-model="obscoreP" placeholder="P" min="0"
                 :style="highlightIfError('obscoreP')"
                 :disabled="isClose"/>
        </div>
        <div class="form__row__item">
          <label normal>FT (<i># of Full Term</i>)</label>
          <input type="number" class="m" v-model="obscoreFT" placeholder="FT" min="0"
                 :style="highlightIfError('obscoreFT')"
                 :disabled="isClose"/>
        </div>
        <div class="form__row__item">
          <label normal>Pr (<i># of Preterm</i>)</label>
          <h3><input type="number" class="m" v-model="obscorePr" placeholder="Pr" min="0"
                     :style="highlightIfError('obscorePr')"
                     :disabled="isClose"/></h3>
        </div>
        <div class="form__row__item">
          <label normal>Ab (<i># of Abortions</i>)</label>
          <h3><input type="number" class="m" v-model="obscoreAb" placeholder="Ab" min="0"
                     :style="highlightIfError('obscoreAb')"
                     :disabled="isClose"/></h3>
        </div>
        <div class="form__row__item">
          <label normal>LB (<i># of Currently Living</i>)</label>
          <input type="number" class="m" v-model="obscoreLB" placeholder="LB" min="0"
                 :style="highlightIfError('obscoreLB')"
                 :disabled="isClose"/>
        </div>
      </div>
      <!-- Removed in version 7
      <div class="form__row--x">
        <label>Past Obstetric Conditions</label>
        <smd-select ref="obhistorySelect"
                    v-model="obstetricHistoryModel"
                    :hide-tags="true"
                    :hide-selected="true"
                    :options="mutiSelectLookup"
                    @open="onOBHistoryOpen"
                    @search-change="onOBHistorySearch"
                    v-if="!isClose"/>
      </div>
      -->

      <template v-if="showHistory">
        <div class="data-entry" >
          <label>Category</label>
          <label>Condition</label>
        </div>

        <div class="data-entry" v-for="(value, key) in obstetricHistory" :key="key">
          <p><strong>{{ value.categoryId | decodeObstetricHistoryCategory }}</strong></p>
          <p>
            {{ key | decodeObstetricHistoryCondition }}
          </p>
          <smd-btn icon="smd-icon-action-delete"
                   @click="removeMultiSelectItem(key)"
                   v-if="!isClose"/>
        </div>
      </template>

    </div>

  </div>
</template>

<script>
  import caseFormMultiSelectMixin from './case-form-section-with-multiselect'

  import {mapActions} from 'vuex'
  import {createHelpers} from 'vuex-map-fields'
  import {
    REF_MATERNAL_FETAL_FORM_OBSTETRIC_HISTORY,
    REF_MATERNAL_FETAL_FORM_OBSTETRIC_HISTORY_CONDITIONS_OBJ,
  } from "../../../store/modules/referencedata2";
  import {
    GETTER_CASE_FORM_STATE_FIELD,
    SETTER_CASE_FORM_STATE_FIELD,
    ACTION_UPDATE_OBSTETRIC_HISTORY
  } from '../../../store/forms/case-form-state'

  import withSectionValidation from '../../../mixins/with-section-validation';
  import withErrorValidation from '../../../mixins/with-error-validation-mixin';
  import validations from '../../../validations/obhistory-section-validation';

  const {mapFields} = createHelpers({
    getterType: GETTER_CASE_FORM_STATE_FIELD,
    mutationType: SETTER_CASE_FORM_STATE_FIELD
  });

  export default {
    mixins: [caseFormMultiSelectMixin, withSectionValidation, withErrorValidation],
    props:{
      obstetricHistory: null
    },
    computed: {
      ...mapFields([
        'obscoreG',
        'obscoreP',
        'obscoreFT',
        'obscorePr',
        'obscoreAb',
        'obscoreLB',
        'isClose'
      ]),
      showHistory() {
        return !!Object.keys(this.obstetricHistory).length;
      },
      obstetricHistoryModel: {
        get() {
          return this.generateMultiSelectModel();
        },
        set(v) {
          const model = this.transformMultiSelectModel(v);
          this.doUpdateMultiSelectModel(model);
        }
      }
    },
    methods: {
      ...mapActions({
        doUpdateMultiSelectModel: ACTION_UPDATE_OBSTETRIC_HISTORY
      }),
      getRawModelForMultiSelect() {
        return this.obstetricHistory;
      },
      onOBHistoryOpen() {
        this.$emit('add');
      },
      onOBHistorySearch(q) {
        this.$emit('search-change', q);
      }
    },
    validationSection: 'obScore',
    multiSelectLookupName: REF_MATERNAL_FETAL_FORM_OBSTETRIC_HISTORY,
    multiSelectConditionsLookupName: REF_MATERNAL_FETAL_FORM_OBSTETRIC_HISTORY_CONDITIONS_OBJ,
    multiSelectFormSection: 'obstetricHistory',
    validations
  }
</script>

<style scoped>
  .form__row {
    flex-wrap: wrap;
  }
</style>
